import { ApiOrario, ImpostazioniRitiro } from "../interfaces/custom/orario";

interface OrariDiGiorno {
    giorno: string,
    orari_range: any[]
}

function getOrariDisponibiliPerGiorno(split : number, orari : ApiOrario[], giorno : number) {
    let orari_di_giorno = orari.filter(orario => orario.giorno_della_settimana == giorno);

    let orari_raggrupati = [];

    for (let orario of orari_di_giorno) {
        let start = orario.orario_inizio;
        let end = orario.orario_fine;
        for (; start + split <= end; start += split) {
            orari_raggrupati.push([start, start + split]);
        }
    }

    return orari_raggrupati;

}

export function getOrariDisponibiliPerFinestra(impostazioni_ritiro : ImpostazioniRitiro, orari : ApiOrario[]) {
    let orariDisponibiliPerFinestra : OrariDiGiorno[] = [];

    let giorno = new Date().getDay();
    for (let i = 0; i <= impostazioni_ritiro.finestra; i++) {
        let idxGirono = (giorno + i) % 7;
        let date = new Date();
        date.setDate(date.getDate() + i);

        let orari_di_giorno : OrariDiGiorno = {
            giorno: date.toISOString(),
            orari_range: getOrariDisponibiliPerGiorno(impostazioni_ritiro.split_fasce, orari, idxGirono)
        }

        if (orari_di_giorno.orari_range.length) {
            orariDisponibiliPerFinestra.push(orari_di_giorno);
        }
    }


    let now = Date.now() / 1000 / 60;
    
    for (let orari_di_giorno of orariDisponibiliPerFinestra) {
        let giorno_time = convertToMinutes(orari_di_giorno.giorno);
        let startLength = orari_di_giorno.orari_range.length;
        orari_di_giorno.orari_range = orari_di_giorno.orari_range.filter(orario => {
            return now + impostazioni_ritiro.delay <= giorno_time + orario[0]
        });
        let endLength = orari_di_giorno.orari_range.length;
        if (startLength == endLength)
            break;
    }

    orariDisponibiliPerFinestra = orariDisponibiliPerFinestra.filter(o => o.orari_range.length);
    return orariDisponibiliPerFinestra;
}

function convertToMinutes(date_string) {
    let d = new Date(date_string);
    return d.setHours(0, 0, 0, 0) / 1000 / 60;
}
